import "./Footer.css";

const Footer = () => (
  <footer className="footer">
    <a
      href="https://github.com/Pedro-Ribas-Moreira"
      className="link footer__link"
    >
      Created By Pedro Moreira
    </a>
  </footer>
);

export default Footer;
